document.addEventListener('DOMContentLoaded', function() {
    // Active class for header categories navigation
	const $nav = $('.header__categories__nav');
	
	// Remove all active classes on page load
	$nav.find('li').removeClass('active');
	$('body').removeClass('categories__nav--is-active');
	
	$nav.on('click', 'li:has(.categories__subnav)', function(e) {
		e.stopPropagation(); // Prevent event from bubbling to document
		
		const $clickedLi = $(this);
		const wasActive = $clickedLi.hasClass('active');
		
		// Remove active class from all li elements
		$nav.find('li').removeClass('active');
		
		// If clicked element wasn't active, add active class to it
		if (!wasActive) {
			$clickedLi.addClass('active');
		}

		// Toggle .categories__nav--is-active on body if any li has .active class
		if ($nav.find('li.active').length > 0) {
			$('body').addClass('categories__nav--is-active');
		} else {
			$('body').removeClass('categories__nav--is-active');
		}
	});

	// Close navigation when clicking outside
	$(document).on('click', function(e) {
		if (!$(e.target).closest('.header__categories__nav').length) {
			$nav.find('li').removeClass('active');
			$('body').removeClass('categories__nav--is-active');
		}
	});
});